// extracted by mini-css-extract-plugin
export default {"pageControls":"PageControls-module__pageControls____PRfj","disabled":"PageControls-module__disabled___oU0dZ"};